import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import login from '../views/login.vue'

// import lung_route from '../components/lung/router/index'

import { ssGet, view_is_edit } from "../utils/utils";
import { confirm } from "../api";

const other_route = [
  // ...lung_route,
];

const routes = [
  {
    path: '',
    redirect: '/homeView',
  },
  {
    path: '/homeView',
    name: 'homeView',
    component: HomeView,
    children: [
      // // study列表页
      // {
      //   path: '/reportTable',
      //   name: 'reportTable',
      //   component: () => import('../views/reportTable.vue')
      // },
      // 设置
      {
        path: '/settingView',
        name: 'settingView',
        component: () => import('../components/setting/setting.vue')
      },
      //用户管理
      {
        path: '/patientSetting',
        name: 'patientSetting',
        component: () => import('../components/setting/patient/index.vue')
      },
      {
        path: '/patientInfo',
        name: '/patientInfo',
        component: () => import('../components/setting/patient/patientInfo.vue')
      },
      //患者管理
      {
        path: '/hospaList',
        name: 'hospaList',
        component: () => import('../components/hospa/hospaList.vue')
      },
      //我的患者
      {
        path: '/myhospaList',
        name: 'myhospaList',
        component: () => import('../components/hospa/myhospaList.vue')
      },
      {
        path: '/hospaInfo',
        name: 'hospaInfo',
        component: () => import('../components/hospa/hospaInfo.vue')
      },
      {
        path: '/hospaSample',
        name: 'hospaSample',
        component: () => import('../components/hospa/hospaSample.vue')
      },
      {
        path: '/ocrList',
        name: 'ocrList',
        component: () => import('../components/ocr/index.vue')
      },
      {
        path: '/chatHistory',
        name: 'chatHistory',
        component: () => import('../components/chatHistory.vue')
      },
      {//字典配置
        path: '/postMessage',
        name: 'postMessage',
        component: () => import('../components/post_message/index.vue')
      },
      {//客服配置
        path: '/serviceView',
        name: 'serviceView',
        component: () => import('../components/platform/customer/index.vue')
      },
      {//表单配置
        path: '/surveyView',
        name: 'surveyView',
        component: () => import('../components/platform/survey/index.vue')
      },
      {//表单配置
        path: '/squesView',
        name: 'squesView',
        component: () => import('../components/questionnaire/index.vue')
      },
      {//表单配置
        path: '/articleView',
        name: 'articleView',
        component: () => import('../components/platform/article.vue')
      },
      {
        path: '/applyView',
        name: 'applyView',
        component: () => import('../components/setting/medical/apply.vue')
      },
      {
        path: '/medicalView',
        name: 'medicalView',
        component: () => import('../components/setting/medical/medical.vue')
      },
      {
        path: '/hash',
        name: 'hash',
        component: () => import('../components/setting/hash.vue')
      },
      {
        path: '/pagetableView',
        name: 'pagetableView',
        component: () => import('../components/setting/pagetable.vue')
      },
      {
        path: '/ulog',
        name: 'ulog',
        component: () => import('../components/setting/ulog.vue')
      },
      {
        path: '/tools',
        name: 'tools',
        component: () => import('../components/setting/tools.vue')
      },

      //药品管理
      {
        path: '/medication',
        name: 'medication',
        component: () => import('../components/setting/medication.vue')
      },
      {//随访配置
        path: '/follow',
        name: 'follow',
        component: () => import('../components/platform/follow/follow.vue')
      },
      {//随访配置
        path: '/followInfo',
        name: 'followInfo',
        component: () => import('../components/platform/follow/followInfo.vue')
      },
      {//字典配置
        path: '/dictionaries',
        name: 'dictionaries',
        component: () => import('../components/setting/dictionarie/index.vue')
      },
      {//字典配置
        path: '/statistics',
        name: 'statistics',
        component: () => import('../components/statistics.vue')
      },
      {//大屏配置
        path: '/dataDashboard',
        name: 'dataDashboard',
        component: () => import('../components/dataDashboard.vue')
      },
      {//课题配置
        path: '/issueView',
        name: 'issueView',
        component: () => import('../components/setting/issue/issueView.vue')
      },
      {//导出配置
        path: '/exportConfig',
        name: 'exportConfig',
        component: () => import('../components/setting/issue/exportConfig.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {//字典配置
    path: '/food',
    name: 'food',
    component: () => import('../components/hospa/layer/food.vue')
  },
  {
    path: '/jump',
    name: 'jump',
    component: () => import('../components/jump.vue')
  },
  {
    path: '/loginBytoken',
    name: 'loginBytoken',
    component: () => import('../views/loginBytoken.vue')
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('../views/unauthorized.vue')
  },
  // 问卷填写 doc
  {
    path: '/baseQuestion',
    name: 'baseQuestion',
    component: () => import('../components/hospa/layer/new_question/base_question.vue')
  },
]

// const checkRepetition = (name, list) => {
//   let has = 0;
//   list.map(v => {
//       if(v.name === name) {
//           has++
//       }
//   });
//   if(has > 1) {
//       console.log('路由重复：' + name)
//   }
// };
// other_route.forEach(ot => {
//   if(ot.is_children) {
//       // 子路由
//       routes.forEach(ro => {
//           if(ot.is_children === ro.name) {
//               ro.children.push(ot);
//               checkRepetition(ot.name, ro.children)
//           }
//       })
//   } else {
//       routes.push(ot);
//       checkRepetition(ot.name, routes)
//   }
// });

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 跳转拦截
  // 跳转拦截 1否2是
  let is_edit = ssGet('view_is_edit');
  if (is_edit == '2') {
    // 正在修改
    confirm('页面存在未保存数据，确定要离开当前页吗？', {
      title: '提示',
      conText: '确认',
      canText: '取消',
      showClose: false
    }).then(() => {
      view_is_edit(1);
      next()
    }).catch(() => { })
  } else if (is_edit == 'upload') {
    confirm('数据正在上传中，是否要离开当前上传页面？', {
      title: '提示',
      conText: '确认',
      canText: '取消',
      showClose: false
    }).then(() => {
      view_is_edit(1);
      next()
    }).catch(() => { })
  } else {
    next()
  }
});
router.afterEach(() => {
});

export default router